import { render, staticRenderFns } from "./TestimonialDeadlineHandler.vue?vue&type=template&id=f76bd9d6&scoped=true&"
import script from "./TestimonialDeadlineHandler.vue?vue&type=script&lang=js&"
export * from "./TestimonialDeadlineHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76bd9d6",
  null
  
)

export default component.exports